import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_w4s2ssyjfg: FaireBrandEntity = {
  token: "b_w4s2ssyjfg",
  type: "brand",
  name: "Hico Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/e520de757373c99593b800e5c994cdaf3f42d6a1bbd8fbd183e0574a39c85af8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2778b06a636d20183985f1c1ea8ff51a7aa3a6b68d52f2ad9bbbbbc95ed487ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e520de757373c99593b800e5c994cdaf3f42d6a1bbd8fbd183e0574a39c85af8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2778b06a636d20183985f1c1ea8ff51a7aa3a6b68d52f2ad9bbbbbc95ed487ac.jpeg",
  location: "Hico, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 156,
  isInsider: true,
  description:
    "Welcome to Hico Candle Co., a Hico, Texas-based candle company specializing in hand-poured small-batch candles, room sprays, and wax melts. Each small-batch creation receives our utmost care and attention, ensuring exceptional quality. Our products transform spaces with warmth and ambiance. Explore our collection of unique fragrances, and indulge in the delightful glow that only a candle can provide.",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:41.563Z",
    importedBy: "entity-db-cli",
  },
};
